import Autocomplete from "vuejs-auto-complete";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);

Vue.component("autocomplete", Autocomplete);
Vue.component("v-autocomplete", require("./components/layout/autocomplete.vue"));
Vue.component("v-email", require("./components/elements/email.vue"));
Vue.component("v-text", require("./components/elements/text.vue"));
Vue.component("v-hidden", require("./components/elements/hidden.vue"));
Vue.component("v-textarea", require("./components/elements/textarea.vue"));
Vue.component("v-select", require("./components/elements/select2.vue"));
Vue.component("v-datepicker", require("./components/elements/datepicker.vue"));
Vue.component("v-timepicker", require("./components/elements/timepicker.vue"));
Vue.component("v-currency", require("./components/elements/currency.vue"));
Vue.component("v-number", require("./components/elements/number.vue"));
Vue.component("v-phone", require("./components/elements/phone.vue"));
Vue.component("v-checkbox", require("./components/elements/checkbox.vue"));
Vue.component("v-radio", require("./components/elements/radio.vue"));
Vue.component("v-counter", require("./components/elements/counter.vue"));
Vue.component("v-adhoc", require("./components/reports/adhoc.vue"));
Vue.component("v-filter", require("./components/reports/filter.vue"));
Vue.component("v-layout-select", require("./components/layout/select.vue"));
Vue.component("v-layout-datepicker", require("./components/layout/datepicker.vue"));
Vue.component("v-layout-timepicker", require("./components/layout/timepicker.vue"));
Vue.component("v-layout-phone", require("./components/layout/phone.vue"));
Vue.component("v-layout-text", require("./components/layout/text.vue"));
Vue.component("v-layout-textarea", require("./components/layout/textarea.vue"));
Vue.component("v-layout-number", require("./components/layout/number.vue"));
Vue.component("v-contact-manager", require("./components/placement/contact-manager.vue"));
Vue.component("v-hotel-manager", require("./components/placement/hotel-manager.vue"));
Vue.component("v-hotel-placement", require("./components/placement/hotel-placement.vue"));
Vue.component("v-hotel-invoice-requests", require("./components/placement/hotel-invoice-requests.vue"));
Vue.component("v-alert-row", require("./components/alerts/alert-row.vue"));
Vue.component("v-alert-calendar", require("./components/alerts/alert-calendar.vue"));
Vue.component("v-contact-approval", require("./components/alerts/contact-approval.vue"));
Vue.component("v-hotel-approval", require("./components/alerts/hotel-approval.vue"));
Vue.component("v-chart", require("./components/reports/chart.vue"));
Vue.component("v-invoice-action", require("./components/placement/invoice-action.vue"));
Vue.component("v-invoice-request", require("./components/placement/invoice-request.vue"));
Vue.component("v-payable-action", require("./components/placement/payable-action.vue"));
Vue.component("v-payable-request", require("./components/placement/payable-request.vue"));
Vue.component("v-payment-application-action", require("./components/placement/payment-application-action.vue"));
Vue.component("v-void-action", require("./components/placement/void-action.vue"));
Vue.component("v-status-report", require("./components/reports/status-report.vue"));
Vue.component("v-additional-status-request", require("./components/reports/additional-status-request.vue"));



// WEBPACK FOOTER //
// ./resources/assets/js/vue.js